import React from 'react';
import './Content.css';
import Helpers from './Helpers';
import Button from './Button';

class Content extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lang : "de",
			dictionary : {},
			fontSize: 15,
			menu_status: "closed",
			update: "",
			datetime: "",
			core_data: {},
			active_season: "2022",
			seasons: {},
			teams: {
				dict:{},
				arr:[]
			},
			test_teams : [],
			teams_info: {},
			matches: {},
			reset_matches: {},
			reset_teams: {},
			rounds: {},
			round_count: 0,
			active_round: 1,
			ready: false,
			error: false,
			natural_statuses: ["","normal","n.V.","n.P."],
			statuses: {
				"abgebr.": {
					id:"abgebr.",
					name:"abgebr.",
					label:"abgebr.",
					cls: "canceled",
					c_status : "untippable"
				},
				"abges.": {
					id:"abges.",
					name:"abges.",
					label:"abges.",
					cls: "abges",
					c_status : "untippable"
				},
				"normal": {
					id:"normal",
					name:"Normal",
					label:"Regulär",
					cls: "normal",
					c_status : "tippable"
				},
				"n.V.": {
					id:"n.V.",
					name:"nach Verlängerung",
					label:"n.V.",
					cls: "nV",
					c_status : "untippable"
				},
				"n.P.": {
					id:"n.P.",
					name:"nach Penalty",
					label:"n.P.",
					cls: "nP",
					c_status : "untippable"
				},
				"coming": {
					id:"coming",
					name:"coming",
					label:"offen",
					cls: "coming",
					c_status : "tippable"
				},
				"finished": {
					id:"finished",
					name:"finished",
					label:"beendet",
					cls: "finished",
					c_status : "untippable"
				},
				"canceled": {
					id:"canceled",
					name:"canceled",
					label:"abgebrochen",
					cls: "canceled",
					c_status : "untippable"
				},
				"undefined": {
					id:"undefined",
					name:"undefined",
					label:"undefined",
					cls: "undefined",
					c_status : "untippable"
				},
			},
			supplements: ["normal","n.V.","n.P."],
			reset_warned: false,
			sorting_note: false,
			sorting_note_teams : [],

			testing: false,
			test_criterion: 6,
			test_epoch: 1,
			test_status: "ready",
			test_start_time : new Date(),
			test_time: 0,



		}

		this.translate = this.translate.bind(this)


		this.randomUpperLimit = 3

		this.criteria = [
			{
				id: 0,
				title: {
					de: "Punkte",
					fr: "Points"
				},
				text: {
					de: "erzielte <b>Punkte</b> am Ende der Meisterschaft",
					fr: "<b>points</b> à la fin du championnat"
				}
			},
			{
				id: 1,
				title: {
					de: "Anzahl Matches",
					fr: ""
				},
				text: {
					de: "Tiefere Anzahl <b>Spiele</b> der punktegleichen Mannschaften (bevor sämtliche Spiele getippt wurden)",
					fr: ""
				}
			},
			{
				id: 2,
				title: {
					de: "P aus DB",
					fr: ""
				},
				text: {
					de: "Höhere Anzahl <b>Punkte aus den direkten Begegnungen</b>",
					fr: ""
				}
			},
			{
				id: 3,
				title: {
					de: "TD",
					fr: ""
				},
				text: {
					de: "Bessere <b>Tordifferenz aus allen Spielen</b>",
					fr: ""
				}
			},
			{
				id: 4,
				title: {
					de: "T",
					fr: ""
				},
				text: {
					de: "Höhere Anzahl der geschossenen <b>Tore aus allen Spielen</b>",
					fr: ""
				}
			},
			{
				id: 5,
				title: {
					de: "TD aus DB",
					fr: ""
				},
				text: {
					de: "Bessere <b>Tordifferenz aus den direkten Begegnungen</b>",
					fr: ""
				}
			},
			{
				id: 6,
				title: {
					de: "T aus DB",
					fr: ""
				},
				text: {
					de: "Höhere Anzahl der geschossenen <b>Tore aus den direkten Begegnungen</b>",
					fr: ""
				}
			},
			{
				id: 7,
				title: {
					de: "AT",
					fr: ""
				},
				text: {
					de: "Höhere Anzahl der geschossenen <b>Auswährtstore aus allen Spielen</b>",
					fr: ""
				}
			},
			{
				id: 8,
				title: {
					de: "AT aus DB",
					fr: ""
				},
				text: {
					de: "Höhere Anzahl der geschossenen <b>Auswährtstore aus den direkten Begegnungen</b>",
					fr: ""
				}
			},
			{
				id: 9,
				title: {
					de: "NL Operations",
					fr: ""
				},
				text: {
					de: "Besteht danach immer noch Gleichheit, entscheidet <b>NL Operations</b> über das weitere Vorgehen.",
					fr: ""
				}
			},
			
		]

		this.start_testing = this.start_testing.bind(this)
		this.match_output = this.match_output.bind(this)
	}

	
// TRANSLATION ------------------------------------------------->
translate(phrase) {
	let lang = this.state.lang;
	let output = phrase;
	if(this.state.dictionary.hasOwnProperty(phrase)) {
		if(this.state.dictionary[phrase].hasOwnProperty(lang)) {
			output = this.state.dictionary[phrase][lang];
		}
		else {
			if(this.state.ready===true) {
				console.log(phrase)
			}
		}
	}
	else {
		if(this.state.ready===true) {
			console.log(phrase)
		}

	}
	return output;
}

createDictionary(src) {
	let dict_local = {}
	src.map((item,k) => {
		dict_local[item.de] = item;
		return false;
	})
	return dict_local
}
// TRANSLATION <-------------------------------------------------


	componentDidMount() {
		this.fetchData();
	}

	openUrl(url) {
		window.open(url)
	}

	toggle_menu() {
		let status_local = this.state.menu_status;
		if(status_local==="closed") {
			status_local="open"
		}
		else {
			status_local="closed"
		}
		this.setState({
			menu_status: status_local
		})
	}

	set_supplement(match_id,supplement) {
		let matches_local =  JSON.parse(JSON.stringify(this.state.matches));
		let match_local = matches_local[match_id];
		match_local.supplement = supplement;

		
		matches_local = this.calc_all_matches(matches_local)
		let teams_local = this.calc_all_teams(this.state.teams,matches_local)

		this.blink_team(teams_local.dict[match_local["team_0"]].key)
		this.blink_team(teams_local.dict[match_local["team_1"]].key)

		this.setState({
			matches:matches_local,
			teams: teams_local
		})
	}

	reset_match(match_id) {
		let matches_local =  JSON.parse(JSON.stringify(this.state.matches));
		matches_local[match_id]= this.state.reset_matches[match_id];
		let teams_local = this.calc_all_teams(this.state.teams,matches_local)

		this.setState({
			matches:matches_local,
			teams: teams_local
		})
	}

	set_goal(match_id,team_id,type) {
		let matches_local =  JSON.parse(JSON.stringify(this.state.matches));
		let match_local = matches_local[match_id];
		
		match_local.goals_0 = match_local.goals_0*1;
		match_local.goals_1 = match_local.goals_1*1;

		if(type==="plus") {
			match_local["goals_"+team_id]+=1;
		}
		if(type==="minus") {
			match_local["goals_"+team_id]-=1;
		}
		// Testing --->
		if(type==="random") {
			let randomNumber = this.randomIntFromInterval(0,this.randomUpperLimit);

			if(team_id===1) {
				while(match_local["goals_0"]===randomNumber) {
					randomNumber =  this.randomIntFromInterval(0,this.randomUpperLimit);
				}
			}

			match_local["goals_"+team_id] = randomNumber;
		}
		// Testing <---
		if(match_local["goals_"+team_id]<0) {
			match_local["goals_"+team_id] = 0
		}

		matches_local = this.calc_all_matches(matches_local)
		let teams_local = JSON.parse(JSON.stringify(this.state.teams));
		teams_local = this.calc_all_teams(teams_local,matches_local)

		this.setState({
			matches:matches_local,
			teams:teams_local
		})

		// this.blink_team(teams_local.dict[match_local["team_"+team_id]].key)
		this.blink_team(teams_local.dict[match_local["team_0"]].key)
		this.blink_team(teams_local.dict[match_local["team_1"]].key)

		if((match_local["goals_0"]+match_local["goals_1"]>0) && match_local["goals_0"]!==match_local["goals_1"]) {
			match_local.c_status = "tipped";
		}
		else {
			match_local.c_status = "untipped"
		}


	}

	mark_active_round(round_id) {
		this.setState(
			{
				active_round: round_id
			}
		)
	}

	urlVars() {

		let lang = Helpers.getUrlVar("lang");
		if(lang==="de" || lang==="fr") {
			this.setState({
				lang: lang
			})
		}


		let testing = Helpers.getUrlVar("testing");		
		if(testing==="true") {
			this.setState({
				testing: true
			})
		}

	}

	clean_goals(goals) {
		let output = goals;
		if(isNaN(output) || output.length<=0) {
			output = ""
		}
		else {
			output = parseInt(output)
		}
		return output
	}

	calc_all_matches(matches_data) {

		// TEAMS
		let teams_local =  JSON.parse(JSON.stringify(this.state.teams));
		teams_local.arr= [];

		// ROUNDS
		let rounds_local =  JSON.parse(JSON.stringify(this.state.rounds));
		Helpers.o2a(rounds_local).items.map((round,k) => {
			round.matches = [];
			round.finished = [];
			round.unplayed = [];
			round.untipped = []
			round.status = "open";
			return false;
		})
		
		// // MATCHES
		// Helpers.o2a(matches_data).items.map((match,l) => {
		// 	match = this.calc(match);

		// 	rounds_local[match.round].matches.push(match.id)
		// 	if(match.status==="coming") {
		// 		rounds_local[match.round].unplayed.push(match.id)
		// 	}

		// 	return false;
		// })

		// Helpers.o2a(rounds_local).items.map((round,k) => {
		// 	if(round.unplayed.length<=0) {
		// 		round.status="closed";
		// 	}
		// 	else if(round.untipped.length>0) {
		// 		round.status='tippable'
		// 	}
		// 	return false;
		// })

		// MATCHES
		Helpers.o2a(matches_data).items.map((match,l) => {
			match = this.calc(match);
			rounds_local[match.round].matches.push(match.id)
			if(match.c_status==="tippable" || match.c_status==="tipped") {
				rounds_local[match.round].unplayed.push(match.id)
				if(match.c_status==="tippable") {
					rounds_local[match.round].untipped.push(match.id)
				}
			}
			return false;
		})

		Helpers.o2a(rounds_local).items.map((round,k) => {
			if(round.unplayed.length<=0) {
				round.status="closed";
			}
			else if(round.untipped.length>0) {
				round.status='tippable'
			}
			return false;
		})


		Helpers.o2a(teams_local.dict).items.map((team,k) => {
			teams_local.arr.push(team);
			return false;
		})	


		this.setState({
			rounds:rounds_local,
			teams: teams_local
		})
		return matches_data
	}

	calc(match_data) {
		let match = match_data
		match.winner = "winner_none"
		match.goals_total = match.goals_0+match.goals_1;
		if(match.goals_total>0) {
			if(match.goals_0>match.goals_1) {
				match.winner = "winner_0"
			}
			else if(match.goals_0<match.goals_1) {
				match.winner = "winner_1"
			}
			else {
				match.winner = "winner_tie"
			}
		}
		else if((match.c_status==="tipped" || match.c_status==="untipped") && match.goals_0 === match.goals_1) {
			match.winner = "winner_tie"
		}
		return match_data
	}

	calc_logic_all_encounters(teams,matches) {

		Helpers.o2a(teams.dict).items.map((team,k) => {
			team = this.reset_team(team);
			return false;
		})	

		// MATCHES
		Helpers.o2a(matches).items.map((match,l) => {

			// 	TEAM POINT CALCULATION
			let g_0 = match['goals_0']
			let g_1 = match['goals_1']

			let points = [0,0];
			if(g_0+g_1>0 && g_0!==g_1) {
				teams.dict[match['team_0']]['match_count']+=1;
				teams.dict[match['team_1']]['match_count']+=1;
				
				teams.dict[match['team_0']]['goals']+=g_0;
				teams.dict[match['team_1']]['goals']+=g_1;

				// Auswärtstore
				teams.dict[match['team_1']]['goals_as_guest']+=g_1;
				// teams.dict[match['team_0']]['goals_as_host']+=g_0;


				teams.dict[match['team_0']]['goals_received']+=g_1;
				teams.dict[match['team_1']]['goals_received']+=g_0;

				teams.dict[match['team_0']]['goals_difference'] = teams.dict[match['team_0']]['goals']-teams.dict[match['team_0']]['goals_received'];
				teams.dict[match['team_1']]['goals_difference'] = teams.dict[match['team_1']]['goals']-teams.dict[match['team_1']]['goals_received'];

				let supplement = match.supplement;

				if(supplement === "normal") {
					if (g_0>g_1) {
						points[0] = 3
						points[1] = 0
						
						teams.dict[match['team_0']]['wins_3']+=1
						teams.dict[match['team_1']]['losses']+=1
					}

					if (g_0<g_1) {
						points[0] = 0
						points[1] = 3

						teams.dict[match['team_0']]['losses']+=1
						teams.dict[match['team_1']]['wins_3']+=1				
					}
				}
				else if (supplement === "n.V." || supplement === "n.P.") {
					if (g_0>g_1) {
						points[0] = 2
						points[1] = 1
						
						teams.dict[match['team_0']]['wins_2']+=1
						teams.dict[match['team_1']]['losses_1']+=1
					}
					if (g_0<g_1) {
						points[0] = 1
						points[1] = 2
						
						teams.dict[match['team_0']]['losses_1']+=1
						teams.dict[match['team_1']]['wins_2']+=1
					}
				}			
				else {
					console.log(supplement)
				}


			}
			teams.dict[match['team_0']]['points'] += points[0]
			teams.dict[match['team_1']]['points'] += points[1]		

			// 	TEAM POINT CALCULATION END

			// Tore aus Direktbegegnungen -->
			if(g_0+g_1>0 && g_0!==g_1) {

				if(!teams.dict[match.team_0].encounters.hasOwnProperty(match.team_1)) {
					teams.dict[match.team_0].encounters[match.team_1] = {
						points : 0,
						goals : 0,
						goals_as_guest : 0,
						goals_received : 0,
						goals_difference : 0,
						match_count: 0,
					}
				}
				if(!teams.dict[match.team_1].encounters.hasOwnProperty(match.team_0)) {
					teams.dict[match.team_1].encounters[match.team_0] = {
						points : 0,
						goals : 0,
						goals_as_guest : 0,
						goals_received : 0,
						goals_difference : 0,
						match_count: 0,
					}
				}

				teams.dict[match.team_0].encounters[match.team_1].match_count += 1;
				teams.dict[match.team_0].encounters[match.team_1].points += points[0];
				teams.dict[match.team_0].encounters[match.team_1].goals += match.goals_0;
				teams.dict[match.team_0].encounters[match.team_1].goals_received += match.goals_1;
				teams.dict[match.team_0].encounters[match.team_1].goals_difference += match.goals_0;
				teams.dict[match.team_0].encounters[match.team_1].goals_difference -= match.goals_1;

				teams.dict[match.team_1].encounters[match.team_0].match_count += 1;
				teams.dict[match.team_1].encounters[match.team_0].points += points[1];
				teams.dict[match.team_1].encounters[match.team_0].goals += match.goals_1;
				teams.dict[match.team_1].encounters[match.team_0].goals_received += match.goals_0;
				teams.dict[match.team_1].encounters[match.team_0].goals_difference += match.goals_1;
				teams.dict[match.team_1].encounters[match.team_0].goals_difference -= match.goals_0;
				// goals as guest 
				teams.dict[match.team_1].encounters[match.team_0].goals_as_guest += match.goals_1;
				// Tore aus Direktbegegnungen <--
			}
			return false;
		})

		teams.arr = [];
		Helpers.o2a(teams.dict).items.map((team,k) => {
			team.points_per_game = team.points/team.match_count;
			teams.arr.push(team);
			return false;
		})	

		return teams;

	}




	calc_all_teams(teams,matches) {
		let teams_local = this.calc_logic_all_encounters(teams,matches)

		let sorted_teams_arr = this.sort_teams(teams);


		let sorting_note_local = false;
		let sorting_note_teams_local = [];

		teams_local.arr = [];
		sorted_teams_arr.map((team,k) => {
			team.standing = k+1

			teams_local.arr.push(team)
			teams_local.dict[team.id] = team;

			if(team.criterion*1>=9) {
				sorting_note_local = true;
				sorting_note_teams_local.push(team.short_name)
			}
			return false;
		})

		this.setState({
			sorting_note : sorting_note_local,
			sorting_note_teams : sorting_note_teams_local
		})
	
		return(teams_local)
	}

	


	sort_by_all_encounters(teams_unsorted,criterion,sorter,direction) {
		// console.log(teams_unsorted,criterion,sorter)
		let by = sorter;
		let local = JSON.parse(JSON.stringify(teams_unsorted)); // Deep Copy	
		
		function sortNow(a,b) {
			let returner = 0;
			
		
				if(a[by]*1 > b[by]*1) {
					a.sorted = true;
					b.sorted = true;
					a.criterion = criterion;
					b.criterion = criterion;
					returner = -1
				}
				else if(a[by]*1 < b[by]*1) {
					a.sorted = true;
					b.sorted = true;
					a.criterion = criterion;
					b.criterion = criterion;
					returner = 1
				}
				else {
					a.sorted = false;
					b.sorted = false;
					returner = 0;
				}
			

		
		
			return returner*direction
		}

		local.sort(sortNow);

		// gather sets
		let sets = {
			arr : [],
			dict : {}
		};

		local.map((team)=>{
			let set_id = by+"_"+team[by];
		
				if(sets.dict.hasOwnProperty(set_id)) {
				sets.dict[set_id].push(team)
				}
				else {
					sets.dict[set_id] = [team]
				}
			
			
			return false
		})

		Helpers.o2a(sets.dict).items.map((set)=>{
			sets.arr.push(set)
			return false
		})

		return sets.arr;

	}





	sort_by_criterion(teams_unsorted,criterion) {
		// console.log({criterion})
		let sorter = "points";
		let scope = "all";
		switch(criterion) {
			case 0: sorter = "points";
					scope = "all";
			break;

			case 1: sorter = "match_count";
			scope = "all";
			break;

			case 2: sorter = "points";
					scope = "direct";
			break;

			case 3: sorter = "goals_difference";
					scope = "all";
			break;

			case 4: sorter = "goals";
					scope = "all";
			break;

			case 5: sorter = "goals_difference";
					scope = "direct";
			break;

			case 6: sorter = "goals";
					scope = "direct";
			break;

			case 7: sorter = "goals_as_guest";
					scope = "all";
			break;

			case 8: sorter = "goals_as_guest";
					scope = "direct";
			break;

			case 9: sorter = "nl_operations";
					scope = "all";
			break;

			default : 	sorter = "points";
						scope = "all";
		}
		
		let sort_result = {
			sorted : [],
			unsorted : []
		}
		// console.log(criterion,scope)
		// console.log({teams_unsorted})

		let direction = 1;

		if(sorter === "match_count") {
			direction = -1;
		}


		if(scope==="all") {
			 sort_result = this.sort_by_all_encounters(teams_unsorted,criterion,sorter,direction)
		}
		else if(scope==="direct") {
			sort_result = this.sort_by_direct_encounters(teams_unsorted,criterion,sorter,direction)
		}


		return sort_result
	}

	sort_new(teams_unsorted) {
		let teams = [];
		let criterion = 0;

		console.log("------------------")
		console.log({criterion})
		let sets = this.sort_by_criterion(teams_unsorted,criterion)

		sets.map((set_1)=>{
			if(set_1.length>1) {
				criterion = 1;
				console.log("------------------")
				console.log({criterion})

				set_1 = this.sort_by_criterion(set_1,criterion)
				console.log({set_1})

				set_1.map((set_2)=>{
					if(set_2.length>1) {
						criterion = 2;
						// // FOR DEBUGGING OVERRIDE --->
						// criterion = 9 // !!!!!!!!!
						// // FOR DEBUGGING OVERRIDE <---

						console.log("------------------")
						console.log({criterion})

						// FOR DEBUGGING OVERRIDE WITH CRITERION 9 --->
						// set_2.map((team)=>{
						// 	team.criterion = criterion;
						// 	teams.push(team);
						// 	return false;
						// })
						// FOR DEBUGGING OVERRIDE <---


						set_2 = this.sort_by_criterion(set_2,criterion)
						console.log({set_2})

						set_2.map((set_3)=>{
							if(set_3.length>1) {
								criterion = 3;
								console.log("------------------")
								console.log({criterion})
								set_3 = this.sort_by_criterion(set_3,criterion)
								console.log({set_3})

								set_3.map((set_4)=>{
									if(set_4.length>1) {
										criterion = 4;
										console.log("------------------")
										console.log({criterion})
										set_4 = this.sort_by_criterion(set_4,criterion)
										console.log({set_4})

										set_4.map((set_5)=>{
											if(set_5.length>1) {
												criterion = 5;
												console.log("------------------")
												console.log({criterion})
												set_5 = this.sort_by_criterion(set_5,criterion)
												console.log({set_5})
		
												set_5.map((set_6)=>{
													if(set_6.length>1) {
														criterion = 6;
														console.log("------------------")
														console.log({criterion})
														set_6 = this.sort_by_criterion(set_6,criterion)
														console.log({set_6})
				
														set_6.map((set_7)=>{
															if(set_7.length>1) {
																criterion = 7;
																console.log("------------------")
																console.log({criterion})
																set_7 = this.sort_by_criterion(set_7,criterion)
																console.log({set_7})
						
																set_7.map((set_8)=>{
																	if(set_8.length>1) {
																		criterion = 8;
																		console.log("------------------")
																		console.log({criterion})
																		set_8 = this.sort_by_criterion(set_8,criterion)
																		console.log({set_8})

																		set_8.map((set_9)=>{
																			if(set_9.length>1) {
																				criterion = 9;
																				console.log("------------------")
																				console.log({criterion})
																																								
																				set_9.map((team)=>{
																					team.criterion = criterion;
																					teams.push(team);
																					return false;
																				})
																				console.log("last criterion reached")
																				console.log({set_9})
		
																			} // 9
																			else {
																				teams.push(set_8[0])
																			}
																			return false;
																		})
																	} // 8
																	else {
																		teams.push(set_8[0])
																	}
																	return false;
																})
															} // 7
															else {
																teams.push(set_7[0])
															}
															return false;
														})
													} // 6
													else {
														teams.push(set_6[0])
													}
													return false;
												})
											} // 5
											else {
												teams.push(set_5[0])
											}
											return false;
										})
									} // 4
									else {
										teams.push(set_4[0])
									}
									return false;
								})
							} // 3
							else {
								teams.push(set_3[0])
							}
							return false;
						})
					} // 2
					else {
						teams.push(set_2[0])
					}
					return false;
				})
			} // 1
			else {
				teams.push(set_1[0])
			}
			return false;
		})

		console.log({teams})

		return teams;
	}

	sort_teams(teams) {
		let teams_unsorted = JSON.parse(JSON.stringify(teams)).arr; // Deep Copy
		console.clear()
		let teams_sorted = this.sort_new(teams_unsorted)
		return teams_sorted
	}

	calc_logic_direct_encounters_sums(teams_unsorted) {
		let opponent_ids = []

		teams_unsorted.map((team) => {
			opponent_ids.push(team.id)
			return false;
		})

		teams_unsorted.map((team) => {
			let encounters_direct_sums = {
				direct_encounters_count : 0,
				points : 0,
				goals_difference : 0,
				goals : 0,
				goals_as_guest : 0,
			}

			Object.keys(team.encounters).map((key, index) => {
				if(opponent_ids.indexOf(key)>-1) {
					encounters_direct_sums.direct_encounters_count += 1;
					let encounter = team.encounters[key];
					// console.log(encounter)
					encounters_direct_sums.points += encounter.points*1;
					encounters_direct_sums.goals_difference += encounter.goals_difference*1;
					encounters_direct_sums.goals += encounter.goals*1;
					encounters_direct_sums.goals_as_guest += encounter.goals_as_guest*1;
				}
				return false;
			})

			team.encounters_direct_sums = encounters_direct_sums;

			return false;
		})
		// console.log({teams_unsorted})
		return teams_unsorted
	}

	sort_by_direct_encounters(teams_unsorted,criterion,sorter,direction) {

		let by = sorter;
		let local = JSON.parse(JSON.stringify(teams_unsorted)); // Deep Copy	
		local = this.calc_logic_direct_encounters_sums(teams_unsorted);

		function sortNow(a,b) {
			let returner = 0;

			if(a.encounters_direct_sums[by]*1 > b.encounters_direct_sums[by]*1) {
				a.sorted = true;
				b.sorted = true;
				a.criterion = criterion;
				b.criterion = criterion;
				returner = -1
			}
			else if(a.encounters_direct_sums[by]*1 < b.encounters_direct_sums[by]*1) {
				a.sorted = true;
				b.sorted = true;
				a.criterion = criterion;
				b.criterion = criterion;
				returner = 1
			}
			else {
				returner = 0;
				a.sorted = false;
				b.sorted = false;
			}
			
			return returner;
		}

		local.sort(sortNow);

		// gather sets
		let sets = {
			arr : [],
			dict : {}
		};

		local.map((team)=>{
			let set_id = by+"_"+team.encounters_direct_sums[by];

			if(sets.dict.hasOwnProperty(set_id)) {
			sets.dict[set_id].push(team)
			}
			else {
				sets.dict[set_id] = [team]
			}
		
			return false
		})

		Helpers.o2a(sets.dict).items.map((set)=>{
			sets.arr.push(set)
			return false
		})

		// console.log({sets})
		return sets.arr;

	}

	reset_team(team) {
		const keys = [
			"match_count",
			"wins_3",
			"wins_2",
			"losses_1",
			"losses",
			"points",
			"goals",
			"goals_received",
			"goals_difference",
			// "goals_as_host",
			"goals_as_guest",
			"standing",
			"points_per_game"
		];
		keys.map((key)=>{
			team[key] = 0
			return false
		})
		team.note="";
		team.sorted = false;
		this.setState({
			sorting_note:false,
			sorting_note_teams:[]
		})
		team.encounters = {}
		

		return team;
	}

	calcCalcTime(ts) {
		let dtme = 0;
		if(ts.length>3) {
			dtme = Helpers.string2date(ts)
		}
		else {
			dtme = Helpers.string2date("1979-01-01 21:00")
		}
		return dtme;
	}

	dhm (ms) {
		const days = Math.floor(ms / (24*60*60*1000));
		const daysms = ms % (24*60*60*1000);
		const hours = Math.floor(daysms / (60*60*1000));
		const hoursms = ms % (60*60*1000);
		const minutes = Math.floor(hoursms / (60*1000));
		const minutesms = ms % (60*1000);
		const sec = Math.floor(minutesms / 1000);
		return days + "d:" + hours + "h:" + minutes + ":" + sec;
	  }

	
	preProcess(data) {
		data.matches.map((match,k) => {
			match.calcTime = this.calcCalcTime(match.datetime)
			return false;
		})

		data.matches = Helpers.sorting(data.matches,"datetime",-1);


		// SEASONS
		data.seasons = Helpers.sorting(data.seasons,"year",-1);
		let seasons_local = {};
		let active_season_local = "2022";
		data.seasons.map((season,k) => {
			seasons_local[season['year']] = season;
			if(season['active']*1===1) {
				active_season_local = season['year']
			}
			return false
		})
		this.urlVars();

		// rounds
		let rounds_local = {}
		let round_count = 0;


		// teams

		let teams_local = {
			dict: {},
			arr: []
		};

		let teams_info_local = {}

		data.teams_info.map((team_info,k) => {
			teams_info_local[team_info.name] = team_info
			return false;
		})

		// matches
		data.matches = Helpers.sorting(data.matches,"round",1);
		let matches_local = {};

		data.matches.map((match,k) => {
			if(match['season']===active_season_local) {

				// TEAMS
				if(!teams_local.hasOwnProperty(match['team_0'])) {
					let team = {
						"id": match['team_0'],
						"picUrl": "",
						"key": match['team_0'],
						"name": match['team_0'],
						"short_name": match['team_0'],
						"match_count": 0,
						"wins_3": 0,
						"wins_2": 0,
						"losses_1": 0,
						"losses": 0,
						"points":0,
						"goals":0,
						"goals_received": 0,
						"goals_difference": 0,
						// "goals_as_host": 0,
						"goals_as_guest": 0,
						"standing": 0,
						"points_per_game": 0,
						"note": "",
						"encounters" : {}
					}
					if(teams_info_local.hasOwnProperty(team.name)) {
						if(teams_info_local[team.name].pic_id.length>1) {
							team.picUrl = "./img/logos/"+teams_info_local[team.name].pic_id+".png"
							team.key = teams_info_local[team.name].pic_id;
							// team.key = Math.random;
						}
						else {
							team.picUrl = "./img/logos/logo-blank.png"
						}
						team.short_name = teams_info_local[team.name].short_name
						if(this.state.lang==="fr") {
							if(teams_info_local[team.name].hasOwnProperty("short_name_fr")) {
								team.short_name = teams_info_local[team.name].short_name_fr
							}
						}
					}
					else {
						console.log(team.name)
					}
					teams_local.dict[team.id] = team;
				}

				match.id = ""+match.id
				match.round = parseInt(match.round)
				match.goals_0 = this.clean_goals(match.goals_0);
				match.goals_1 = this.clean_goals(match.goals_1);
				match.goals_total = match.goals_0+match.goals_1;
				// match.datetime = Helpers.string2date(match.datetime)
				match.supplement = match.supplement.trim()
				if(match.supplement.length<=0) {
					match.supplement = "normal"
				}

				// OT SO MIGRATION
				//
				//
				if(match.supplement==="OT") {
					match.supplement = "n.V."
				}
				if(match.supplement==="SO") {
					match.supplement = "n.P."
				}
				// 
				//
				//
				
				matches_local[match['id']] = match;

				if(!rounds_local.hasOwnProperty(match['round'])) {
					rounds_local[match['round']] = {
						id: match['round'],
						matches: [],
						unplayed: [],
						over: [],
						status: "open"
					}
					round_count++;
				}

				match.status = "undefined"
				match.c_status = "undefined"

				if(this.state.natural_statuses.indexOf(match.supplement)<=-1) {
					match.status = match.supplement
				}
				else if(match.goals_total>0) {
					match.status = "finished"
					match.c_status = "tipped"
				}
				else {
					match.status = "coming"
				}

				if(this.state.statuses.hasOwnProperty(match.status)) {
					match.c_status = this.state.statuses[match.status].c_status;
				}

				if(match.winner==="winner_0") {
					match.c_status = "tippable"
				}

				///////////////////////////////
				///////////////////////////////
				///////////////////////////////
				// TWEAK FOR ONGOING GAMES --->
				if(match.status_raw !== "Ende") {
					match.status = "coming";
					match.c_status = "tippable"
				}
				// TWEAK FOR ONGOING GAMES <---
				///////////////////////////////
				///////////////////////////////
				///////////////////////////////

				match.calcTime = this.calcCalcTime(match.datetime)
				match.deltaTime = match.calcTime-new Date();
				match = this.calc(match);
			}

			return false
		})


		this.setState({
			seasons: seasons_local,
			rounds: rounds_local,
			teams: teams_local,
			teams_info: teams_info_local,
			active_season: active_season_local,
			round_count: round_count,
			ready: true,
		})

		matches_local = this.calc_all_matches(matches_local)
		teams_local = this.calc_all_teams(teams_local,matches_local)

		let active_round_local = this.get_start_round(matches_local)


		this.setState({
			active_round: active_round_local,
			matches: matches_local,
			reset_matches: matches_local,
			teams:teams_local,
			reset_teams:teams_local
		})
	}

	refactoring(data) {
		// let data_local = [];
		// data.map((item,k) => {
		// 	data_local.push(item);
		// 	return false;
		// })
		return(data)
	}

	fetchData() {
		let d = new Date();
		let cacheBuster = (d.getMonth()+1)+"-"+d.getDate()+"-"+d.getHours()+"-"+d.getMinutes();

		let data_merged = {}
		let data_meta = {}
		let data_matches = {}

		let url_meta="./data/bulk.json?"+cacheBuster;
		let url_matches="./data/data_matches.json?"+cacheBuster;

		fetch(url_meta)
			.then(response_meta => response_meta.json())
				.then((response_meta) => {
					data_meta = response_meta
				
					fetch(url_matches)
						.then(response_matches => response_matches.json())
							.then((response_matches) => {
								data_matches = response_matches

								data_merged = data_meta

								data_merged.data.matches = data_matches.data.matches;

								data_merged.meta.update = data_matches.meta.update

								let dictionary_local = this.createDictionary(response_meta.data.dictionary);



								this.setState({
									update : data_merged.meta.update,
									dictionary : dictionary_local

								})

								this.preProcess(data_merged.data)

							})
				})
					
	}

	calc_pseudo(rank) {
		let padding = this.state.fontSize*0.2;
		let height = this.state.fontSize+(3*padding)
		let top = (rank-1)*(height)
		let tbodyHeight = (this.state.teams.arr.length)*(height)+this.state.teams.arr.length/2;
		let answer = {
			top: top,
			padding: padding,
			height: height,
			tbodyHeight: tbodyHeight
		}
		return answer
	}

	get_start_round_old(rounds) {
		let start_round = 0;
		Helpers.o2a(rounds).items.map((round,k) => {
			if(round.unplayed.length>0 && start_round===0) {
				start_round = round.id;
			}
			return false;
		})
		if(start_round===0) {
			start_round = 1;
		}
		return start_round;
	}

	get_start_round(matches) {
		let start_round = 0;
		let current_delta = 9999999999;
		Helpers.o2a(matches).items.map((match,k) => {
			//console.log(match)
			if(match.status==="coming") {
				if(match.deltaTime > -(24*60*60*1000) && match.deltaTime<current_delta) {
				//if(Math.abs(match.deltaTime)<Math.abs(current_delta) && current_delta>(24*60*60*1000)) {
					//current_delta = Math.abs(match.deltaTime);
					current_delta = match.deltaTime;
					start_round = match.round;
				}				
			}

			return false;
		})
		if(start_round===0) {
			start_round = 1;
		}
		return start_round;
	}

	init_reset() {
		let reset_warned_local = this.state.reset_warned
		if(reset_warned_local===false) {
			reset_warned_local = true;
		}
		else {
			this.reset();
			reset_warned_local = false;
		}
		this.setState({
			reset_warned:reset_warned_local
		})
	}

	cancel_reset() {
		this.setState({
			reset_warned:false
		})
	}

	reset() {
		this.setState({
			matches:this.state.reset_matches,
			teams:this.state.reset_teams,
			reset_warned: false,
			active_round: this.get_start_round(this.state.matches)
		})
	}

	jump_to(round_id) {
		let element = document.getElementById(round_id);
		let target = document.getElementById('rounds-wrapper');
		target.scrollTop = element.offsetTop;
		this.mark_active_round(round_id)
	}

	set_round(round_id) {
		this.setState({
			active_round:round_id
		})
	}

	browse_round(dir) {
		let round_local = this.state.active_round;
		if (dir===1) {
			round_local++;
		}
		else if(dir===-1) {
			round_local--;
		}

		if(round_local<=0) {
			round_local = this.state.round_count;
		}
		if(round_local>this.state.round_count) {
			round_local = 1;
		}
		this.setState({
			active_round:round_local
		})
	}

	super_browse_round(dir) {
		let current = this.state.active_round;
		let next_round = current;
		if (dir===1) {
			next_round++;
			while(next_round<this.state.round_count && this.state.rounds[next_round].unplayed.length<=0) {
				next_round++
			}
			if(next_round>this.state.round_count) {
				next_round = 1;
			}
		}
		if (dir===-1) {
			next_round--;
			while(next_round>0 && this.state.rounds[next_round].unplayed.length<=0) {
				next_round--;
			}
			if(next_round<=0) {
				next_round = this.state.round_count;
			}
		}
		this.setState({
			active_round:next_round
		})
	}


	blink_team(team_key) {
		// console.log(team_key)
		this.highlight_team(team_key,1);
		setTimeout(function(){
			this.highlight_team(team_key,0)
		}.bind(this),500)
	}

	navi() {
		return(
			<nav className='navi-wrapper'>

				<div className='navi-item-wrapper'>
					<ul className={'extra-nav reset-warning-set_'+this.state.reset_warned}>
						{/* <li className='m-button round-button round-button_super'
							key = {"round_super_prev_prev"}
							onClick = 	{() => {
								this.super_browse_round(-1) 
								}
							}
						>
							<span className="material-icons">&#xeac3;</span>
						</li> */}
						<li className='m-button round-button round-button_super'
							key = {"round_super_prev"}
							onClick = 	{() => {
								this.browse_round(-1) 
								}
							}
						>
							<span className="material-icons">&#xe314;</span>
						</li>

						<li className='m-button reset-button'
							onClick = 	{() => {
								this.init_reset() 
								}
							}
						>
							<span className="material-icons">&#xf053;</span>
						</li>

						<li className='round-indicator'>
							{this.state.active_round}. <span className='spieltag-text'></span>
						</li>
						{/* <li className='s-button round-button round-button_prev'
							key = {"round_prev"}
							onClick = 	{() => {
								this.browse_round(-1) 
								}
							}
						>Zurück</li> 
						<li className={'reset-button'}
							onClick = 	{() => {
								this.reset() 
								}
							}
						>
							Reset
						</li>*/}

						{/* <li className='s-button round-button round-button_next'
							key = {"round_next"}
							onClick = 	{() => {
								this.browse_round(1) 
								}
							}
						>Weiter</li> */}
						<li className='m-button round-button round-button_super'
							key = {"round_super_next"}
							onClick = 	{() => {
								this.browse_round(1) 
								}
							}
						>
							<span className="material-icons">&#xe315;</span>
						</li>
						<li className='m-button round-button round-button_super'
							key = {"round_super_next_next"}
							onClick = 	{() => {
								this.super_browse_round(1) 
								}
							}
						>
							<span className="material-icons">&#xeac9;</span>
						</li>

					</ul>
				</div>
				{
					this.state.reset_warned && 
					<div className="reset-warning">
						<p>
							{this.translate("Klicke erneut auf diesen Button, um den Rechner zurückzusetzen oder wähle abbrechen:")}
						</p>
						<div className='s-button s-button-cancel-reset'
							onClick = 	{() => {
								this.cancel_reset() 
								}
							}
						>{this.translate("Abbrechen")}</div>
						<div className='s-button s-button-confirm-reset'
							onClick = 	{() => {
								this.reset() 
								}
							}
						>{this.translate("Zurücksetzen")}</div>
					</div>
				}
			</nav>

		)
	}

	highlight_team(team_key,state) {
		let element = document.querySelector('.highlight');
		if(state===1) {
			let element_2 = document.querySelector('.standings-wrapper .row-team_'+team_key);
			if(element_2) {
				setTimeout(function(){
					element_2.classList.add("highlight")
				},10)			
			}
		}

		if(state===0) {
			if(element) {
				setTimeout(function(){
					element.classList.remove("highlight")
				},10)			
			}		
			let element_2 = document.querySelector('.standings-wrapper .row-team_'+team_key);
			if(element_2) {
				setTimeout(function(){
					element_2.classList.remove("highlight")
				},10)			
			}
		}
	}

	goal_button_set(match_id,team_id) {
		return(
			<div className='goal-button-set'>
				{this.goal_button(match_id,team_id,"plus")}
				{this.goal_button(match_id,team_id,"minus")}
			</div>
		)
	}

	goal_button(match_id,team_id,type) {
		if(type==="plus") {
			return(
				<div className={'goal-button goal-button-'+type}
					onClick = 	{() => {
						this.set_goal(match_id,team_id,type) 
						}
					}
				>
					<span className="material-icons">&#xe147;</span>
				</div>
			)
		}
		if(type==="minus") {
			return(
				<div className={'goal-button goal-button-'+type}
					onClick = 	{() => {
						this.set_goal(match_id,team_id,type) 
						}
					}
				>
					<span className="material-icons">&#xe15d;</span>
				</div>
			)
		}
						


		return(
			<div className={'goal-button goal-button-'+type}
				onClick = 	{() => {
					this.set_goal(match_id,team_id,type) 
					}
				}
			></div>
		)
	}



	// TESTING ----------------------------------------------------->
	randomIntFromInterval(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min)
	}

	match_output() {
		let matches = this.state.matches;
		// let cols = ["season","round","sortTime","team_0","team_1","goals_0","goals_1","match_status","status","winner","venue","dateTime"];
		let cols = ["season","round","team_0","team_1","goals_0","goals_1","supplement","match_status","status","winner"];
		let rows = [cols];
		let i = 1;
		Helpers.o2a(matches).items.map((match,k) => {
			let line = [i]
			cols.map((col,k)=> {
				line.push(match[col])
				return false;
			})
			rows.push(line)
			i++;
			return false;
		})
		rows[0].unshift("nr");

		let csvContent = "data:text/csv;charset=utf-8,"
			+ rows.map(e => e.join("\t")).join("\n");
		
		var encodedUri = encodeURI(csvContent);
		window.open(encodedUri);

	}

	check_criterion(criterion) {
		Helpers.o2a(this.state.teams.dict).items.map((team,k) => {
			// console.log(team)
			if(team.criterion >= criterion) {
				clearInterval(this.testing_interval)
				console.log("Criterion " + criterion + " found around "+team.name)
				setTimeout(function(){
					this.highlight_team(team.key,1)
				}.bind(this),1000)
				this.setState({
					test_status : "Criterion " + criterion + " found around "+team.name,
					test_time: this.get_test_time()
				})
				// this.match_output()
				console.log(this.state.teams.dict)

			}
			else {
				this.setState({
					test_time: this.get_test_time()
				})
			}
			return false;
		})
	}

	get_test_time() {
		let now = new Date();
		return now-this.state.test_start_time;
	}

	start_testing(mode) {
		// console.clear();
		let matches_ids =  [];
		Helpers.o2a(this.state.reset_matches).items.map((match,k) => {
			if((mode==="Testing all"  && match.c_status!=="ignore") || (mode==="Testing tippable" && match.c_status==="tippable")) {
				matches_ids.push(match.id)
			}
			return false;
		})
		let i = 0;

		clearInterval(this.testing_interval)
		if(mode!=="Stop Test") {
			console.clear();
			this.reset();
			this.testing_interval = setInterval(do_testing.bind(this),25);
			console.log("Test started")
			this.setState({
				test_status : "Testing…",
				test_start_time : new Date(),
				test_time: 0
			})
		}
		else {
			console.log("Test stopped")
			i=0;
			this.setState({
				test_status : "Testing stopped",
				test_epoch : 1,
				test_time: this.get_test_time()

			})
		}

		function do_testing() {
			try {
				this.check_criterion(this.state.test_criterion)
				if(i<matches_ids.length) {
					let test_match_id = matches_ids[i];
					// this.set_supplement(test_match_id,"normal")
					this.set_supplement(test_match_id,this.state.supplements[this.randomIntFromInterval(0,2)])
					this.set_goal(test_match_id,0,"random")
					this.set_goal(test_match_id,1,"random")
					this.set_round(this.state.matches[test_match_id].round)
					i++;
				}
				else {
					console.log("Epoch "+this.state.test_epoch+" complete")
					let epoch_local = this.state.test_epoch+1;
					this.setState({
						test_epoch : epoch_local,
					})
					i=0;
					//clearInterval(this.testing_interval)
				}
			}
			catch(e) {
				clearInterval(this.testing_interval)
				console.log(e)
			}
			
		}
	}

	set_test_criterion(id) {
		this.setState({
			test_criterion : id
		})
	}

	// TESTING <-----------------------------------------------------

	render() {
		return(
			<div className= {"content "+(this.state.testing ? "testing" : "")}
			
			>
				<header className="header">
					<div className='header-container'>
						<h1 className='blick-header'>
							{this.translate("National League Tabellen-Rechner")}
						</h1>
						{
							this.state.test_teams.map((t,k)=>{
								return(
									<div key={k}>{t.id}</div>
								)
							})
						}
						<img 
							onClick = 	{() => {
								this.toggle_menu() 
								}
							}
						className="canihaz" alt="Filter" src="img/cheeseburger.png"></img>						
					</div>
					<nav className={'menu-wrapper menu-wrapper-'+this.state.menu_status}>
						<div className='menu'>
						{this.state.ready === true &&
							<div className='menu-item-wrapper'>
								<nav className='rounds-nav-wrapper'>
									<ul className='rounds-nav'>
									{
										Helpers.o2a(this.state.rounds).items.map((round,k) => {
											let cls = "round_"+round.status;
											if(round.id===this.state.active_round) {
												cls = cls+=" active"
											}
											return(
												<li className={'s-button round-button round-button_'+round.id+" "+cls}
													id = {"round-button_"+round.id}

													key = {round.id}
													onClick = 	{() => {
														this.set_round(round.id) 
														}
													}
												>{round.id}</li>
											)
										})
									}
									</ul>
								</nav>
							</div>						
						}		
						
					


						</div>
					</nav>
					
				</header>
				{this.state.ready === false &&
					<div className='loading'>
						<div className='spinner-ring'><div></div><div></div><div></div><div></div></div>
					</div>
				}


				{this.state.testing === true &&
				<section className='section_testing'>

					<Button
						name = {"Testing all"}
						id = {"Testing all"}
						active_id = {"Testing all"}
						button_handler = {this.start_testing}
						translate = {this.translate}
					></Button>
					<Button
						name = {"Stop Test"}
						id = {"Stop Test"}
						active_id = {"Stop Test"}
						button_handler = {this.start_testing}
						translate = {this.translate}
					></Button>
					<Button
							name = {"Matchdata"}
							id = {"Matchdata"}
							active_id = {"Matchdata"}
							button_handler = {this.match_output}
							translate = {this.translate}
					></Button>
					<div className='test_info'>
						<div>
							Looking for: {this.criteria[this.state.test_criterion].title[this.state.lang]} [{this.state.test_criterion}]
						</div>
						<div>
							Epoch: {this.state.test_epoch}
						</div>
						<div>
							Status: {this.state.test_status}
						</div>
						<div>
							Time: {this.dhm(this.state.test_time)}
						</div>
					</div>
				</section>
				}

				{this.state.ready === true &&

				<div className="main">
					{/* <div className='note'>
						Die Spieltage entsprechen nicht den offiziellen Runden.
					</div> */
					}
					{
						this.navi()
					}
					<section className='section section-matches'>
						
						<div className='rounds-wrapper' id = 'rounds-wrapper'>
							{
							Helpers.o2a(this.state.matches).items.map((match,k) => {
								if(this.state.active_round===match.round) {
									if(this.state.teams.dict.hasOwnProperty(match.team_0) && this.state.teams.dict.hasOwnProperty(match.team_1 )) {

										return(
										<div className={'match-wrapper filter-round filter-round_'+match.round+' supplement_'+this.state.statuses[match.supplement].cls + ' match-c_status_' + match.c_status  + ' match-status-raw_' + match.status_raw + ' match-status_'+this.state.statuses[match.status].cls + ' match_'+match.id + ' match-' + match.winner } key = {match.id} id={match.id}>
											<div className='match-info'>
												{/* <div className='match-info-item match-info-item_round'>
													Runde {match.round}
												</div> */}
												<div className='match-info-item match-info-item_id'>
													Match {match.id}
												</div>
												<div className='match-info-item match-info-item_date'>
													{
														this.state.lang==="de" &&
														Helpers.write_date(match.datetime,"D. Mon. YYYY HH:MM")
													}
													{
														this.state.lang==="fr" &&
														Helpers.write_date(match.datetime,"D. Mon. YYYY HH:MM fr")
													}
												</div>
												<div className='match-info-item match-info-item_date_short'>
													{
														Helpers.write_date(match.datetime,"D. M. HH:MM")
														//match.datetime
													}
												</div>
												<div className='match-info-item match-info-item_status'>
													{this.state.statuses[match.status].label}
												</div>

												<div className='match-info-item match-info-item_status_raw'>
													{this.translate(match.status_raw)}
												</div>


												<div className='match-info-item tick'>✓</div>
												{
												(match.c_status === "tipped") && 
												<div className='xs-button xs-reset-button'
													title = {this.translate("Match zurücksetzen")}
													onClick = 	{() => {
														this.reset_match(match.id) 
														}
													}
												>
													<span className="material-icons">&#xf053;</span>
												</div>
												}

											</div>
											<div className='encounter-wrapper'>
												{
												this.state.teams.dict[match.team_0].picUrl.length>3 && 
												<img 
													className = "logo-pic logo-pic_0"
													src = {this.state.teams.dict[match.team_0].picUrl}
													alt = {match.team_0}
												>
												</img>
												}
												<div className='team team_0'>
													{/* {match.team_0} */}
													{this.state.teams.dict[match.team_0].short_name}
												</div>
												<div className='goals goals_0'
													onClick = 	{() => {
														if(match.status==="coming") {
															this.set_goal(match.id,0,'plus') 
															}
														}													
													}
												>
													{match.goals_0.toString()}
												</div>
												<div className='colon'>:</div>
												<div className='goals goals_1'
													onClick = 	{() => {
														if(match.status==="coming") {
															this.set_goal(match.id,1,'plus') 
															}
														}
													}
												>
													{match.goals_1.toString()}

												</div>
												<div className='team team_1'>
													{/* {match.team_1} */}
													{this.state.teams.dict[match.team_1].short_name}

												</div>
												{
												this.state.teams.dict[match.team_1].picUrl.length>3 && 
												<img 
													className = "logo-pic logo-pic_1"
													src = {this.state.teams.dict[match.team_1].picUrl}
													alt = {match.team_1}
												>
												</img>
												}

											</div>

											<div className='goal-buttons goal-buttons_0'>
												{this.goal_button_set(match.id,0)}
											</div>	
											<div className='supplements-wrapper'>
												<ul className='supplement'>
												{
													this.state.supplements.map((supplement_id,k) => {
														let supplement = this.state.statuses[supplement_id]
														return(
															<li key={k} className={'s-button supplement-button supplement-button_'+this.state.statuses[supplement.id].cls}
																title = {this.translate(supplement.name)}
																onClick = 	{() => {
																	this.set_supplement(match.id,supplement.id) 
																	}
																}
															>
																{this.translate(supplement.label)}
															</li>  	
														)
													})
												}
													{/* <li 
														className='s-button reset-button'
														title = "Spiel zurücksetzen"
														onClick = 	{() => {
															this.reset_match(match.id)
															}
														}
													>
													<span className="material-icons">&#xf053;</span>
													</li> */}
												</ul>
												<div className='supplement-text'>
													{this.translate(this.state.statuses[match.supplement].label)}
												</div>
											</div>
											<div className='goal-buttons goal-buttons_1'>
												{this.goal_button_set(match.id,1)}
											</div>	
										</div>
											
										)
									}
									else {
										return false
									}
								}
								else {
									return false
								}
								
							})

							}
						</div>
					</section>

					{
						this.navi()
					}

					
					<section className='section section-standings'>
						<div className='words'>
							<h2>{this.translate("Tabelle")}</h2>
							<div className='note'>
								{this.translate("Um die Tabelle neu zu berechnen, tippe oben im Spielkalender die verbleibenden Spiele der Saison (+/–).")}
							</div>	
						</div>
					

						<div className='standings-wrapper'>

							<div className='pseudo-table'
								style = {{
									fontSize:this.state.fontSize,
									height:this.calc_pseudo(0)['tableHeight']
								}}
							>
								<div className='pseudo-thead'>
									{/* DE */}
									{this.state.lang==="de" &&
									<div className='pseudo-tr'>
										<div className='pseudo-th column-standing'>
											#
										</div>
										<div className='pseudo-th column-name'>
											Team
										</div>
										<div className='pseudo-th column-match_count'>
											Sp<span className='longform-text'>iele</span>
										</div>
										<div className='pseudo-th column-goals'>
											T<span className='longform-text'>ore</span>
										</div>
										<div className='pseudo-th column-goals_difference'>
											T<span className='longform-text'>or</span>-Diff.
										</div>
										<div className='pseudo-th column-points'>
											P<span className='longform-text'>unkte </span>
										</div>			
										<div className='pseudo-th column-points_per_game'>
											Ø-P<span className='longform-text'>unkte </span>
										</div>
										<div className='pseudo-th column-criterion'>
											K
											{/* <span className='longform-text'>riterium </span> */}
										</div>
										{/* <div className='pseudo-th column-decided'>
											Decided
										</div> */}
									</div>
									}
									{/* FR */}
									{this.state.lang==="fr" &&
									<div className='pseudo-tr'>
										<div className='pseudo-th column-standing'>
											#
										</div>
										<div className='pseudo-th column-name'>
											Équipe
										</div>
										<div className='pseudo-th column-match_count'>
											M<span className='longform-text'>atchs</span>
										</div>
										<div className='pseudo-th column-goals'>
											Buts<span className='longform-text'></span>
										</div>
										<div className='pseudo-th column-goals_difference'>
											Diff.<span className='longform-text'>d.B.</span>
										</div>
										<div className='pseudo-th column-points'>
											P<span className='longform-text'>oints </span>
										</div>			
										<div className='pseudo-th column-points_per_game'>
											Ø-P<span className='longform-text'>unkte </span>
										</div>
										<div className='pseudo-th column-criterion'>
											K
											{/* <span className='longform-text'>riterium </span> */}
										</div>
										{/* <div className='pseudo-th column-decided'>
											Decided
										</div> */}
									</div>
									}
								</div>
								<ul className='pseudo-tbody'
									style = {{
										height:this.calc_pseudo(1)['tbodyHeight']
									}}
								>
									{
									Helpers.o2a(this.state.teams.dict).items.map((team,k) => {
										return(
											<li key = {team.key} className={'pseudo-tr row-team_'+team.key + ' row-standing_'+team.standing}
												style = {{
													top:this.calc_pseudo(team.standing)['top'],
													padding:this.calc_pseudo(team.standing)['padding'],
													height:this.calc_pseudo(team.standing)['height'],
												}}
											>
												<div className={'pseudo-td column-standing note_'+team.note}>
													<span className='standing-number-wrapper'>
														{
														team.criterion*1<9 ? team.standing+"." : "?"
														// team.standing
														}
													</span>
												</div>
												<div className='pseudo-td column-name'>
													{
													team.picUrl.length>3 && 
													<img 
														className = "logo-pic"
														src = {team.picUrl}
														alt = {team.name}
													>
													</img>
													}
													{/* {team.name} */}
													{team.short_name}

												</div>
											

												<div className='pseudo-td column-match_count'>
													{team.match_count}
												</div>
												<div className='pseudo-td column-goals'>
												{team.goals} : {team.goals_received} 
												</div>
												<div className='pseudo-td column-goals_difference'>
													{team.goals_difference} 
												</div>
												<div className='pseudo-td column-points'>
													{team.points} 
												</div>
												<div className='pseudo-td column-points_per_game'>
													{Math.round(team.points_per_game*1000)/1000} 
												</div>
												<div className='pseudo-td column-criterion'>
													{team.criterion} 
												</div>
												{/* <div className='pseudo-td column-decided'>
													{String(team.decided)} 
												</div> */}
											</li>
										)
									})
									}
								</ul>
							
							</div>
						</div>
					</section>
					{this.state.sorting_note === true &&
					
					<section className='section section-notes'>
						{"?) Zwischen "+this.state.sorting_note_teams.join(" und ")+" würde NL Operations über das weitere Vorgehen entscheiden."}
					</section>
					}
					<section className='section section-help'>
						{this.state.lang==="de" &&
						<ul className='help-items ranking-help-items'>
							<li className="ranking-set ranking-set-1_6">
								<span>
									Für die Tabellenplätze <b>1-6</b> erfolgt nach der Qualifikation der <b>direkte Einzug in die Playoffs.</b>
								</span>
							</li>
							<li className="ranking-set ranking-set-7_10">
								<span>
									Die Teams auf den Rangierungen <b>7-10</b> machen unter sich die letzten zwei <b>Playoff-Plätze</b> aus.
								</span>
							</li>
							<li className="ranking-set ranking-set-11_12">
								<span>
									Für die Teams auf Platz <b>11 und 12</b> bedeutet die Platzierung <b>Saisonende</b>.
								</span>
							</li>
							<li className="ranking-set ranking-set-13_14">
								<span>
									Die Teams auf den Plätzen <b>13 und 14</b> bestreiten den Playout-Final in einer <b>Best-of-7 Serie</b>. Der Verlierer des Playout-Final muss in einer allfälligen Ligaqualifikation gegen den Meister aus der Swiss League antreten.
								</span>
							</li>
						</ul>
						}

						{this.state.lang==="fr" &&
						<ul className='help-items ranking-help-items'>
							<li className="ranking-set ranking-set-1_6">
								<span>
									Après la qualification, les équipes classées de <b>1 à 6 accèdent directement aux playoffs</b> . 
								</span>
							</li>
							<li className="ranking-set ranking-set-7_10">
								<span>
									Les équipes classées de <b>7 à 10</b> se disputent les deux dernières <b>places en playoff</b>. 

								</span>
							</li>
							<li className="ranking-set ranking-set-11_12">
								<span>
									Pour les équipes classées <b>11 et 12</b>, le classement signifie <b>la fin de la saison</b>.
								</span>
							</li>
							<li className="ranking-set ranking-set-13_14">
								<span>
									Les équipes classées <b>13 et 14</b> disputent la finale des play-out dans une <b>série best of 7</b>. 
									Le perdant de la finale des play-out devra affronter le champion de la Swiss League lors d’un éventuel barrage.
								</span>
							</li>
						</ul>
						}


					</section>
					{
						this.state.testing &&
					<section className='section section-help'>
						<ul className='help-items'>
							<li>
								Ein Sieg zu regulärer Spielzeit (60 Minuten) bringt dem Gewinner 3 Punkte, bei Verlängerung (n.V.) oder Penalty (n.P.) erhält er 2 Punkte, der Verlierer 1 Punkt.
							</li>							
							<li>
								Die Rangierung erfolgt aufgrund der <b>Anzahl der erzielten Punkte</b>.
							</li>
							{/* <li>
								Bei Punktegleichstand entscheidet die Bilanz aus den direkten Begegnungen, bei Gleichstand die bessere Tordifferenz, bei gleicher Tordifferenz die höhere Anzahl an erzielten Toren.
							</li> */}
							<li>
								Bei Punktegleichheit gelangen – in der genannten Reihenfolge – die folgenden Kriterien (K) zur Anwendung:
								
							</li>

						</ul>
						
						<ol className='help-items'>
							
						

							{
								this.criteria.map((criterion,k) => {
									if(k>0) {
										return(
											<li key = {k}
											>
												<div className={'cr '+(k===this.state.test_criterion ? "cr_active" : "")}
												
													onClick = 	{() => {
														this.set_test_criterion(criterion.id) 
													}
												}

												>{k}</div>
												<span
													dangerouslySetInnerHTML = {
													{
														__html: criterion.text.de
													}
												}>

												</span>
											</li>
										)
									}
									else {
										return false
									}
									
								})
							}
						</ol>
					
					</section>
					}

			

				</div>

				}

				<footer className="blick-footer">
					© Blick Visuals 2023 | Raphael Röthlin 
					| {this.translate("Daten aktualisiert am")} {this.state.update}
				</footer>
			</div>
		)
	}
}


export default Content;
